import { useIntl } from 'react-intl';

import { Box } from '@/components/Box';
import { Col } from '@/components/Col';
import { getUserTitleLabel } from '@/components/FormFields/TitleField';
import { LegacyButton } from '@/components/LegacyButton';
import { SectionHeader } from '@/components/SectionHeader';
import { Typography } from '@/components/Typography';
import type { CountryCode } from '@/graphql/saleor/api';
import { commonMessages as appointmentMessages } from '@/messages/appointment';
import { commonMessages } from '@/messages/common';
import { useRetailerPageContext } from '@/providers/RetailerPageProvider/RetailerPageProviderContext';

import * as S from './AppointmentConfirmation.styles';

interface AppointmentConfirmationProps {
  countryCode: CountryCode;
  firstName?: string;
  lastName?: string;
  title?: {
    label?: string;
    value?: string;
  } | null;
}

export const AppointmentConfirmation = ({
  countryCode,
  firstName,
  lastName,
  title,
}: AppointmentConfirmationProps) => {
  const { formatMessage } = useIntl();
  const { handleDiscoverCollection } = useRetailerPageContext();

  return (
    <Box data-testid='AppointmentConfirmation'>
      <Box data-testid='AppointmentConfirmationBox' mb={3} mt={5}>
        <SectionHeader
          colorized
          data-testid='AppointmentConfirmationSectionHeader'
          sizeDesktop={50}
          sizeMobile={40}
          text={formatMessage(commonMessages.bookAppointment)}
          textAlign='center'
        />
      </Box>
      <S.CustomerRow data-testid='AppointmentConfirmationCustomerRow'>
        <Col>
          <Typography
            color='secondary'
            data-testid='AppointmentConfirmationReceivedData'
            fontWeight='bold'
            mb={1}
            scale='h4'
            textAlign='center'
          >
            {getUserTitleLabel(countryCode, title) +
              (lastName ? lastName.toUpperCase() + ' ' : '') +
              (firstName ? firstName.toUpperCase() : '')}
          </Typography>
        </Col>
        <Col>
          <Typography
            color='default'
            data-testid='AppointmentConfirmationGratitudeText'
            textAlign='center'
          >
            {formatMessage(appointmentMessages.gratitudeText)}
          </Typography>
          <Typography
            color='default'
            data-testid='AppointmentConfirmationRetailerInTouch'
            textAlign='center'
          >
            {formatMessage(appointmentMessages.retailerInTouch)}
          </Typography>
        </Col>
      </S.CustomerRow>
      <S.Row data-testid='AppointmentConfirmationRow'>
        <Col justifySelf='center'>
          <LegacyButton
            data-testid='AppointmentConfirmationContinueBrowsing'
            isFluid
            onClick={handleDiscoverCollection}
            type='button'
          >
            {formatMessage(appointmentMessages.discoverCollections)}
          </LegacyButton>
        </Col>
      </S.Row>
    </Box>
  );
};
